/**
 * Component that renders a <script> tag with code to track tab visibility.
 *
 * Callers can invoke `window?._opendoor?.tabVisibilityTracker?.getPercentOfTimeTabVisible()`
 * to check what percent of time since navigation start the current tab was in
 * the foreground. This is significant because backgrounded tabs are throttled
 * by browsers, and that throttling can *significantly* impact performance.
 *
 * This code is injected directly into the document response so that the event
 * handler is bound as soon as possible (e.g. without waiting for JS bundles to
 * be downloaded and executed, which can happen seconds later).
 */
export function TabVisibilityTrackerScript() {
  // EXERCISE CAUTION: THE JAVASCRIPT HERE IS NOT MINIFIED, TRANSPILED, OR LINTED.
  const scriptContent = `
    (function () {
      try {
        window._opendoor = window._opendoor || {};
        if (window._opendoor.tabVisibilityTracker) {
          return;
        }

        var lastUpdateAt = performance.now();
        var visibleTime = 0;
        var totalTime = 0;

        function updateTimes(wasVisible) {
          var now = performance.now();
          var timeElapsed = now - lastUpdateAt;
          totalTime += timeElapsed;
          if (wasVisible) {
            visibleTime += timeElapsed;
          }
          lastUpdateAt = now;
        }
        document.addEventListener('visibilitychange', function () {
          updateTimes(document.hidden); // Currently hidden means it was visible up until now
        });

        window._opendoor.tabVisibilityTracker = {
          getPercentOfTimeTabVisible: function () {
            try {
              updateTimes(!document.hidden);
              if (totalTime === 0) {
                return null;
              }
              return Math.round((visibleTime / totalTime) * 100);
            } catch (e) {
              // Sentry may not be initialized yet
              console.error(e);
              return null;
            }
          },
        };
      } catch (e) {
        // We don’t want to block anything on the page, and Sentry may not be initialized yet
        console.error(e);
      }
    })();
  `;

  return <script dangerouslySetInnerHTML={{ __html: scriptContent }} />;
}
